import React from "react";
import {connect} from 'react-redux';
import { Link, Redirect } from "react-router-dom";
import {userLoginFetch, loginUser} from '../../redux/actions/authActions';
import {mfaPending} from '../../redux/actions/mfaActions';

import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

import cabfareLogo from "../../assets/img/cabfare/cabfare-logo.png";
import {OutlineAlert} from "./components/ExtAlerts";

class ExtSignIn extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      isSubmitting: false,
      user: props.user
    };

    // A successful password login dispatches synchronously, which makes this
    // component unmount (Redirect to the MFA screen or the dashboard) before
    // the promise settles. Guard the follow-up setState against that.
    this.isMounted_ = false;
  }

  componentDidMount() {
    this.isMounted_ = true;
  }

  componentWillUnmount() {
    this.isMounted_ = false;
  }

  validateForm = () => this.state.email.length > 0 && this.state.password.length > 0;

  handleChangeUsername = event => {
    this.setState({
      email: event.target.value
    });
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleSubmit = event => {

    event.preventDefault();

    if (this.state.isSubmitting) return null;

    this.setState({isSubmitting: true});

    return this.props.fetchUserLogin(this.state).then((result) => {
      // The reducer keeps the pending MFA marker and `currentUser` error state
      // in sync with the outcome; either way there is nothing left to wait for.
      if (this.isMounted_) {
        this.setState({isSubmitting: false});
      }
      return result;
    });

  }

  render() {
    if (this.props.mfa.pending) {
      // Password accepted, second factor still required. No `currentUser` was
      // written - the pending session is not an authenticated one.
      return this.props.mfa.pending.mfa_enrolled
        ? <Redirect to='/extranet/auth/mfa/verify' />
        : <Redirect to='/extranet/auth/mfa/enrol' />;
    }

    return ( this.props.user.currentUser.id ? ( <Redirect to='/extranet/dashboard' /> ) : (
      <React.Fragment>
        <div className="text-center mt-4">
          <p className="lead">Sign in to your account to continue</p>
        </div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div className="text-center">
                <img
                  src={cabfareLogo}
                  alt="Cabfare"
                  className="img-fluid"
                  width="300"
                  style={{marginBottom: '2rem'}}
                />
              </div>
              { this.props.user.currentUser.error && (
                <>
                  <OutlineAlert
                    color="danger"
                  >
                    {this.props.user.currentUser.message}
                  </OutlineAlert>
                  {/*<div className="alert alert-danger" style={{padding: '1rem'}}></div>*/}
                </>
              ) }
              <Form onSubmit={this.handleSubmit} className="form-login">
                <FormGroup>
                  <Label for="username">Email or Driver ID</Label>
                  <Input
                    bsSize="large"
                    autoFocus
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter your Email or Driver ID"
                    value={this.state.email}
                    onChange={this.handleChangeUsername}
                    autoComplete="username"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="password">Password or PIN</Label>
                  <Input
                    bsSize="large"
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Enter your Password or PIN"
                    value={this.state.password}
                    onChange={this.handleChange}
                    autoComplete="current-password"
                  />
                  <div className="mt-3">
                    <Link to="/extranet/forgot-password">Forgot password?</Link>
                  </div>
                </FormGroup>
{/*
                <div>
                  <CustomInput
                    type="checkbox"
                    id="rememberMe"
                    label="Remember me next time"
                    defaultChecked
                  />
                </div>
*/}
                <div className="text-center mt-3">
                  <Button
                    color="primary"
                    size="lg"
                    disabled={!this.validateForm() || this.state.isSubmitting}
                    type="submit"
                  >
                    Sign in
                  </Button>
                </div>
              </Form>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    ));
  } // render

} // class SignIn

const fetchUserLogin = (user, dispatch) => {
  return userLoginFetch(user, (userObj) => {  // passing state and anonymous fn to userLoginFetch
    // A pending MFA session must NOT go through LOGIN_USER - that would write
    // a current_user cookie for a session the server still considers logged
    // out, and would flush the cache mid-flow. MFA_PENDING records just enough
    // to route to the right MFA screen.
    if (userObj && userObj.mfa_required) {
      return dispatch(mfaPending(userObj));
    }
    return dispatch(loginUser(userObj));
  });
}

const mapStateToProps = store => ({
  user: store.user,
  mfa: store.mfa,
  // sidebar: store.sidebar,
  // layout: store.layout
})

const mapDispatchToProps = dispatch => ({ // implicit return
  fetchUserLogin: (user) => fetchUserLogin(user, dispatch),
})

// export default SignIn;
export default connect(mapStateToProps, mapDispatchToProps)(ExtSignIn);
